// extracted by mini-css-extract-plugin
export default {"card":"kamaThemeCard_card__JGp7j","touchable-opacity":"kamaThemeCard_touchable-opacity__4L+tw","show":"kamaThemeCard_show__o9Wox"};